import React from 'react';
import compositionPhoto1 from '../../img/composition/code-1.png';
import compositionPhoto2 from '../../img/composition/code-2.png';
import compositionPhoto3 from '../../img/composition/code-3.png';

const AboutRight = () => {
    return (
        <div className="right">
            <div className="composition">
                <img src={compositionPhoto1} alt="Code" className="compositionPhoto compositionPhotoP1" />
                <img src={compositionPhoto2} alt="Code" className="compositionPhoto compositionPhotoP2" />
                <img src={compositionPhoto3} alt="Code" className="compositionPhoto compositionPhotoP3" />
            </div>
        </div> // Right
    );
};

export default AboutRight;